module.exports = __webpack_public_path__ + "assets/alerts_white.4c5311dd.svg";